import Vue from 'vue'

Element.prototype.relativeOffset = function (to) {
  var rect_a = this.getBoundingClientRect();
  var rect_b = to.getBoundingClientRect();

  var x = rect_a.left - rect_b.left;
  var y = rect_a.top - rect_b.top;

  return { x, y };
}

Math.UUID = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

MouseEvent.prototype.relativeOffsetByEvent = function (container) {
  var rect = container.getBoundingClientRect();
  var x = this.clientX - rect.left;
  var y = this.clientY - rect.top;

  return { x, y };
}

Vue.prototype.$pulse = function (selector) {
  const el = document.querySelector(selector);
  if(el) {
    el.classList.add('--pulse')
    setTimeout(() => {
      el.classList.remove('--pulse')
    }, 4000);
  } else {
    console.warn('No elem found for pulse');
  }
}

Vue.prototype.$shake = function (selector) {
  const el = document.querySelector(selector);
  if(el) {
    el.classList.add('--shake')
    setTimeout(() => {
      el.classList.remove('--shake')
    }, 500);
  } else {
    console.warn('No elem found for shake');
  }
}

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1) return c/2*t*t + b;
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

Number.prototype.toLetter = function() {
  var mod = this % 26,
      pow = this / 26 | 0,
      out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');
  return pow ? this.toLetter(pow) + out : out;
}


Number.prototype.getAccuracy = function() {
  let str = this.toString().split('.');

  if(str.length === 1) {
    return 0;
  } else {
    return str[1].length;
  }
}


Number.prototype.toFixedGentle = function(max) {
  let accuracy = this.getAccuracy();
  if(accuracy > max) {
    accuracy = max
  }
  return accuracy ? parseFloat(this.toFixed(accuracy)) : this;
}